import { all, fork } from 'redux-saga/effects';
import { watchDataSaga } from './api/apiSaga';
import { watchExampleSaga } from "./example/exampleSaga";
import { watchSearchFilterSaga } from "./searchAndFilter/searchAndFilterSaga";
import { watchChatbotSaga } from "./chatbot/chatbotSaga";
import { watchThreadsSaga } from "./threads/threadsSaga";
import { watchMessagesSaga } from "./messages/messagesSaga";
import { watchFilesSaga } from "./files/filesSaga";
import { watchCatalogSaga } from "./catalog/catalogSaga";
import { watchLapSaga } from "./lap/lapSaga";
import { watchSchemaSaga } from "./schema/schemaSaga";
import { watchAuthSaga } from "./auth/authSaga";
import { watchProjectsSaga } from "./projects/projectsSaga";
import { watchProjectDynamosSaga } from "./projectDynamos/projectDynamosSaga";
import { watchRddsSaga } from "./rdds/rddSaga";
import { watchLocalTaskForceRolesSaga } from "./localTaskForceRoles/localTaskForceRoleSaga";
import { watchLocalCommunityTrainerRolesSaga } from "./localCommunityTrainerRoles/localCommunityTrainerRoleSaga";
import { watchDomainsSaga } from "./domains/domainSaga";
import { watchTerritorialChallenges } from "./territorialChallenges/territorialChallengesSaga";
import { watchDraftsSaga } from "./drafts/draftsSaga";
import { watchPublishedSolutionsSaga } from "./published/publishedSolutionsSaga";
import { watchLapsSaga } from "./laps/lapSaga";
import { watchSolutionProposals } from "./solutionProposals/solutionProposalsSaga";
import { watchAgentsSaga } from "./agents/agentsSaga";

export default function* rootSaga() {
    yield all([
        fork(watchDataSaga),
        fork(watchExampleSaga),
        fork(watchSearchFilterSaga),
        fork(watchChatbotSaga),
        fork(watchThreadsSaga),
        fork(watchMessagesSaga),
        fork(watchFilesSaga),
        fork(watchCatalogSaga),
        fork(watchLapSaga),
        fork(watchSchemaSaga),
        fork(watchAuthSaga),
        fork(watchProjectsSaga),
        fork(watchProjectDynamosSaga),
        fork(watchRddsSaga),
        fork(watchLocalTaskForceRolesSaga),
        fork(watchLocalCommunityTrainerRolesSaga),
        fork(watchDomainsSaga),
        fork(watchTerritorialChallenges),
        fork(watchDraftsSaga),
        fork(watchPublishedSolutionsSaga),
        fork(watchLapsSaga),
        fork(watchSolutionProposals),
        fork(watchAgentsSaga),
    ]);
}
